import React, { useEffect, useState } from "react";
import { Form, Formik, FormikHelpers } from "formik";
import { number, object, string } from "yup";
import { PaymentDetailsFormValues } from "src/models/PaymentDetails.model";
import PaymentDetailsForm from "./PaymentDetailsForm";
import { useOutletContext, useParams } from "react-router-dom";
import { useUpdateOrderPaymentByIdMutation } from "src/services/OfflineOrderService";
import { showToast } from "src/utils/showToaster";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useGetSingleByIdTranscationTotalQuery } from "src/services/transcationService";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";
import usePaymentModes from "src/hooks/usePaymentModes";
import useDrawer from "src/hooks/useDrawer";

const PaymentDetailsFormWrapper = () => {
  const [offlineOrderData]: any = useOutletContext();
  const { orderId } = useParams();
  const [transcations, setTranscations] = useState<any>([]);
  const [advancedAmount, setAdvancedAmount] = useState(0);
  const [mobileForAdv, setMobileForAdv] = useState("");
  const [paymentOrder] = useUpdateOrderPaymentByIdMutation();
  const { paymentMode } = usePaymentModes();
  const { drawer} = useDrawer();
  const getPaymentModes = (type: "PHYSICAL" | "VIRTUAL") => {
    return (
      paymentMode
        ?.filter((pm: any) => pm?.type === type)
        .map((pm: any) => ({
          label: pm?.name,
          value: pm?.value,
          type: pm?.type,
        })) || []
    );
  };
  const physicalModes =
    drawer?.filter((mode: any) => mode?.type === "PHYSICAL") || [];

  const virtualPaymentModes = getPaymentModes("VIRTUAL");
  // Form Initial Values
  const initialValues: PaymentDetailsFormValues = {
    showamountPaid: offlineOrderData?.receivedAmt || "",
    showTotalFees: offlineOrderData?.orderTotal || "",
    showRemainingFees: offlineOrderData?.dueAmt || "",
    totalFees: offlineOrderData?.orderTotal || "",
    amountPaid: offlineOrderData?.amountPaid || "",
    remainingFees: offlineOrderData?.remainingFees || "",
    receivedAmt: offlineOrderData?.dueAmt,
    paymentMode: physicalModes?.map((mode: any) => ({
      name: mode.name,
      value: mode.value,
      quantity: "",
      type: mode.type,
    })),
    courierCharges: offlineOrderData?.courierCharges || "",
    discountAmt: offlineOrderData?.calculatedDisAmt || "",
    adjustAgainstMobile: "",
    remark: offlineOrderData?.remark || "",
    adjustAmount: offlineOrderData.adjustAmount || "",
    totalAdvancePayment: offlineOrderData.advanceAvailable || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    totalFees: string().required("Please enter name"),
    // amountPaid: string().required("Please enter paidamount"),
    remainingFees: number().min(0, "Please enter more then zero"),

    remark: string().required("Please enter remark"),
    adjustAmount: string().test(
      "address-test",
      "amount is not  more then the remaining fees and advance amount",
      (value: any, context) => {
        const { showRemainingFees } = context.parent;
        const { totalAdvancePayment } = context.parent;

        // const pervious = perviousMembershipPrice;
        if (showRemainingFees < value || totalAdvancePayment < value) {
          return false;
        }
        return true;
      }
    ),
  });
const {data: TranscationsData,
     isLoading: TranscationsDataIsLoading,
   isFetching: TranscationsDataIsFetching,}=useGetSingleByIdTranscationTotalQuery(orderId)
  // const {
  //   data: TranscationsData,
  //   isLoading: TranscationsDataIsLoading,
  //   isFetching: TranscationsDataIsFetching,
  // } = useGetAllTranscationsQuery({
  //   limit: 10,
  //   searchValue: "",
  //   params: ["mobile"],
  //   page: 1,
  //   filterBy: [
  //     {
  //       fieldName: "orderId",
  //       value: orderId,
  //     },
  //   ],
  //   dateFilter: {},
  //   orderBy: "createdAt",
  //   orderByValue: -1,
  //   isPaginationRequired: true,
  // });
  useEffect(() => {
    if (!TranscationsDataIsLoading && !TranscationsDataIsFetching) {
      setTranscations(TranscationsData?.data?.transaction);
    }
  }, [TranscationsDataIsLoading, TranscationsDataIsFetching, TranscationsData]);
  const columns: columnTypes[] = [
    {
      field: "dateAndTime",
      headerName: "Date - Time",
      extraClasses: "min-w-[150px] py-1 min-w-[150px]",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => (
        <div>
          <div className="text-slate-700 font-medium text-[14px]">
            {formatedDateTimeIntoIst(row.dateAndTime, "DD MMM yyyy")}
          </div>
          <div className="text-[12px] font-medium text-slate-400">
            {formatedDateTimeIntoIst(row.dateAndTime, "hh:mm A")}
          </div>
        </div>
      ),
    },
    // {
    //   field: "orderId",
    //   headerName: "Order ID",
    //   flex: "flex-[1_1_0%]",
    //   renderCell: (row: any) =>
    //     row?.orderId ? (
    //       <div className="bg-stone-100 p-[3px] flex justify-between items-center rounded-xl  text-xs gap-4 cursor-pointer">
          
    //         {row?.orderId}
    //       </div>
    //     ) : (
    //       "-"
    //     ),
    // },
    { field: "byUserName", headerName: "Create By", flex: "flex-[1_1_0%]" },
    // {
    //   field: "franchiseName",
    //   headerName: "Franchise Name",
    //   flex: "flex-[1_1_0%]",
    // },
    // {
    //   field: "adjustAmount",
    //   headerName: "Adjust Amount",
    //   flex: "flex-[1_1_0%]",
    //   renderCell: (row: any) => <span>&#8377;{row?.adjustAmount || 0} </span>,
    // },
    // {
    //   field: "adjustAgainstMobile",
    //   headerName: "Adjust Against Mobile",
    //   flex: "flex-[1_1_0%]",
    //   renderCell: (row: any) => <span>{row?.adjustAgainstMobile || "-"} </span>,
    // },
    {
      field: "totalAmount",
      headerName: "Amount",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => <div>&#8377;{row?.totalAmount}</div>,
    },
    // {
    //   field: "paymentModeName",
    //   headerName: "Payment Mode",
    //   flex: "flex-[1.8_1.8_0%]",
    //   renderCell: (row: any) => (
    //     <div className="flex flex-col gap-2">
    //       {row?.paymentMode?.map((el: any) => {
    //         return (
    //           <div className="flex justify-between gap-4 items-center border-b border-slate-600 last:border-none">
    //             <span className="text-[12px] font-semibold">
    //               &#8377;{el?.amount}{" "}
    //             </span>
    //             <span className="text-[12px] font-semibold">
    //               {el?.paymentModeName}{" "}
    //             </span>
    //           </div>
    //         );
    //       })}
    //     </div>
    //   ),
    // },
    // {
    //   field: "recepit",
    //   headerName: "PRINT",
    //   flex: "flex-[1_1_0%]",
    //   renderCell: (row: any) => (
    //     // <ATMLoadingButton className="w-20  h-[32px]"></ATMLoadingButton>
    //     <div
    //       onClick={(e) => {
    //         navigate(`/receipt/${row?._id}`);
    //       }}
    //     >
    //       <FcPrint className="cursor-pointer" size={20} />
    //     </div>
    //   ),
    // },
  ];

  // Handle Submit
  const handleSubmit = (
    values: PaymentDetailsFormValues,
    { setSubmitting, resetForm }: FormikHelpers<PaymentDetailsFormValues>
  ) => {
    const totalModeAmount = values.paymentMode.reduce((acc, curr) => {
      return acc + (curr.quantity || 0) * (curr.value || 0);
    }, 0);
    const totalAmount = values?.receivedAmt ? Number(values?.receivedAmt) : 0;
    if (totalModeAmount !== totalAmount) {
      showToast(
        "error",
        "Total recived amount and note total Amount must be equal."
      );
      return setSubmitting(false);
    }
    const formattedValues = {
      remark: values?.remark,
      // adjustAmount: Number(values?.adjustAmount || 0),
      // amountPaid: Number(values?.amountPaid || 0),
      receivedAmt:Number(values?.receivedAmt || 0),
      remainingAmt: Number(values?.remainingFees || 0),
      paymentMode: values.paymentMode
        .filter((mode) => mode.quantity && mode.quantity !== "")
        .map((mode) => ({
          name: mode.name,
          value: Number(mode.value),
          quantity: Number(mode.quantity),
          type: mode.type,
        })),
    };

    paymentOrder({ id: orderId, body: formattedValues }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          setAdvancedAmount(0);
          setMobileForAdv("");
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <Form>
          <PaymentDetailsForm
            onlineMode={virtualPaymentModes}
            setAdvancedAmount={setAdvancedAmount}
            advancedAmount={advancedAmount}
            mobileForAdv={mobileForAdv}
            setMobileForAdv={setMobileForAdv}
            row={transcations}
            coloumns={columns}
            formikProps={formikProps}
          />
        </Form>
      )}
    </Formik>
  );
};

export default PaymentDetailsFormWrapper;
